import { useToast } from '@chakra-ui/react';
import React, { createContext, useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { container } from 'tsyringe';
import axiosInstance from '../../../../api/axiosInstance';
import moment from 'moment';
import { ProvinsiPresenter } from '../../../../../data/presenters/ProvinsiPresenter';
import { getCache, setCache, CACHE_KEYS, CACHE_TTL } from '../../../../misc/CacheStorage';

type ToastStatus = 'error' | 'info' | 'warning' | 'success';

interface Option {
  label: string;
  value: string;
}

export interface FileAssesment {
  id: number;
  assessment_id: number;
  path_file: string;
  nama_file: string;
  mime_type: string;
  created_at: string;
  updated_at: string;
}
interface PengetahuanItem {
  id: number;
  title: string;
  kategori_pengetahuan_id: string;
  description: string;
  category: string;
  path_file: string;
  total_view: number | null;
  review_score: number | null;
  status_publish: number;
  thumbnail: string;
  created_at: string;
  updated_at: string;
  nama_penyelenggara: string;
  jadwal_mulai: string;
  jadwal_selesai: string;
  jam_pelajaran: string;
  link_streaming: string;
  jenis_pengetahuan: string;
  durasi_quiz: number;
  paket_soal_id: number;
  judul_asesmen: string;
  keterangan_asesmen: string;
  has_assessment: boolean;
  is_klinik_khusus: boolean;
  kategoriKlinikKhusus: string;
  review_url: string;
  custom_background_sertifikat: string;
  keterangan_sertifikat: string;
  assessment: {
    assessment_files: FileAssesment[];
    judul: string;
    keterangan: string;
  };
  pengetahuan_mandiri_prasyarat?: Array<{
    id: number;
    pengetahuan_id: number;
    type: string;
    prasyarat: string;
    created_at: string;
    updated_at: string;
  }>;
}
interface IState {
  state: {
    title: string;
    organizer: string;
    kategoriPengetahuanId: Option | null;
    image: File | null;
    video: File | null;
    pdf: File | null;
    description: string;
    link: string;
    publish: boolean;
    url: string;
    urlKategoriPengetahuan: string;
    loadingData: boolean;
    loadingAction: boolean;
    listData: PengetahuanItem[];
    page: number;
    perPage: number;
    pagination: {
      current_page: number;
      total_rows: number;
    } | null;
    category: Option | null;
    mode: string;
    itemId: string;
    listCategory: Option[];
    listVideoTautan: Option[];
    listKategoriPengetahuan: Option[];
    youtubeVideoSelected: Option | null;
    type: 'synchronized' | 'asynchronized';
    linkStream: string;
    startDate: string;
    endDate: string;
    jam_pelajaran: string;
    paketSoalId: number;
    duration: number;
    hasQuiz: boolean;
    hasAssesment: boolean;
    modalQuizMode: 'Tambah' | 'Ubah';
    modalAssesmentMode: 'Tambah' | 'Ubah';
    titleAssesment: string;
    descriptionAssesment: string;
    filesAssesment: File[] | FileAssesment[];
    pengetahuanItem: PengetahuanItem | null;
    isLoadingDelete: boolean;
    is_klinik_khusus: boolean;
    listKategoriKlinikKhusus: Option[];
    kategoriKlinikKhusus: Option | null;
    urlPelatihan: string;
    listPelatihan: Option[];
    pelatihanSelected: Option[] | null;
    search_pelatihan: string;
    urlPengetahuanUtama: string;
    listPengetahuanUtama: Option[];
    pengetahuanUtamaSelected: Option | null;
    review_url: string;
    isKlinikKhususServer: boolean;
    isKategoriKlinikServer: string;
    customSertifikat: File | null;
    keteranganSertifikat: string;
    jenisPersyaratan: '' | 'pendalaman_pelatihan' | 'mandiri';
    pelatihanPrasyaratSelected: Option[];
    tipe_klinik_khusus_mandiri: Option | null;
    prasyarat_klinik_khusus_mandiri: Option[];
    listTipeMandiri: Option[];
    listPrasyaratMandiri: Option[];
  };
  setManajemenPengetahuanState: Function;
  fetchData: Function;
  postData: Function;
  handleDelete: Function;
  handleEdit: Function;
  clearState: Function;
  getListKategoriPengetahuan: Function;
  getPelatihanRelevan: Function;
  getPengetahuanUtama: Function;
  handleSeeDetail: Function;
  getDetailPengetahuan: Function;
  getListPrasyaratMandiri: Function;
  getListTipeMandiri: Function;
}

const initialState: IState = {
  state: {
    title: '',
    organizer: '',
    kategoriPengetahuanId: null,
    image: null,
    video: null,
    pdf: null,
    description: '',
    link: '',
    publish: false,
    url: 'management_content/pengetahuan',
    urlKategoriPengetahuan: 'kategori_pengetahuan',
    loadingData: false,
    loadingAction: false,
    listData: [],
    page: 1,
    perPage: 9,
    pagination: null,
    category: null,
    mode: '',
    itemId: '',
    listCategory: [
      { value: 'video', label: 'Video' },
      { value: 'pdf', label: 'PDF' },
    ],
    listVideoTautan: [
      { value: 'video', label: 'Video Dari Youtube Pintar' },
      { value: 'tautan', label: 'Tautan Video' },
    ],
    listKategoriPengetahuan: [],
    youtubeVideoSelected: null,
    type: 'asynchronized',
    linkStream: '',
    startDate: '',
    endDate: '',
    jam_pelajaran: '',
    paketSoalId: 0,
    duration: 0,
    hasQuiz: false,
    modalQuizMode: 'Tambah',
    hasAssesment: false,
    modalAssesmentMode: 'Tambah',
    titleAssesment: '',
    descriptionAssesment: '',
    filesAssesment: [],
    pengetahuanItem: null,
    isLoadingDelete: false,
    is_klinik_khusus: false,
    listKategoriKlinikKhusus: [
      { value: 'UTAMA', label: 'Tema Utama'},
      { value: 'SUB', label:'Sub Tema'}
    ],
    kategoriKlinikKhusus: null,
    urlPelatihan: 'pelatihan',
    urlPengetahuanUtama: 'management_content/pengetahuan',
    listPelatihan: [],
    pelatihanSelected: [],
    search_pelatihan: '',
    listPengetahuanUtama: [],
    pengetahuanUtamaSelected: null,
    review_url: '',
    isKlinikKhususServer: false,
    isKategoriKlinikServer: '',
    customSertifikat: null,
    keteranganSertifikat: '',
    jenisPersyaratan: '',
    pelatihanPrasyaratSelected: [],
    tipe_klinik_khusus_mandiri: null,
    prasyarat_klinik_khusus_mandiri: [],
    listTipeMandiri: [],
    listPrasyaratMandiri: [],
  },
  setManajemenPengetahuanState: () => {},
  fetchData: () => {},
  postData: () => {},
  handleEdit: () => {},
  handleDelete: () => {},
  clearState: () => {},
  getListKategoriPengetahuan: () => {},
  handleSeeDetail: () => {},
  getDetailPengetahuan: () => {},
  getPelatihanRelevan: () => {},
  getPengetahuanUtama: () => {},
  getListPrasyaratMandiri: () => {},
  getListTipeMandiri: () => {},
};

/**
 * The ManajemenPengetahuanContext provides a context for managing the state related to manajemen pengetahuan.
 * It includes state properties and functions to update the state.
 * @type {React.Context<IState>}
 * @author Bagas Prasetyadi
 */

const Context = createContext<IState>(initialState);
const { Provider: ManajemenPengetahuanProvider } = Context;

/**
 * The provider component that wraps its children with the ManajemenPengetahuanContext and manages the state.
 * @component
 * @param {React.FC} children - The child components that will have access to the context.
 * @returns {JSX.Element} JSX.Element
 */
const Provider: React.FC = ({ children }) => {
  const [state, setState] = useState<IState>(initialState);
  const toast = useToast();
  const history = useHistory();

  const {
    perPage,
    page,
    url,
    urlKategoriPengetahuan,
    title,
    description,
    organizer,
    kategoriPengetahuanId,
    category,
    publish,
    listCategory,
    itemId,
    mode,
    pdf,
    image,
    youtubeVideoSelected,
    linkStream,
    type,
    startDate,
    endDate,
    jam_pelajaran,
    paketSoalId,
    duration,
    titleAssesment,
    descriptionAssesment,
    filesAssesment,
    hasQuiz,
    hasAssesment,
    urlPelatihan,
    urlPengetahuanUtama,
    listKategoriKlinikKhusus,
    is_klinik_khusus,
    kategoriKlinikKhusus,
    pelatihanSelected,
    pengetahuanUtamaSelected,
    review_url,
    customSertifikat,
    keteranganSertifikat,
    jenisPersyaratan,
    pelatihanPrasyaratSelected,
    tipe_klinik_khusus_mandiri,
    prasyarat_klinik_khusus_mandiri,
    listTipeMandiri,
    listPrasyaratMandiri,
  } = state.state;

  const setManajemenPengetahuanState = (
    key: keyof IState['state'],
    value: any
  ) => {
    setState((prevState) => ({
      ...prevState,
      state: {
        ...prevState.state,
        [key]: value,
      },
    }));
  };

  const fetchData = async (status?: string) => {
    try {
      const response = await axiosInstance.get(url, {
        params: {
          status_publish: status ?? '0,1',
          rows: perPage,
          page: page,
        },
      });

      let listData = response.data?.data;

      // Convert durasi_quiz from seconds to minutes
      if (listData && Array.isArray(listData)) {
        listData = listData.map((item) => {
          if (item.durasi_quiz) {
            return {
              ...item,
              durasi_quiz: item.durasi_quiz / 60, // Convert to minutes
            };
          }
          return item;
        });
      }

      setManajemenPengetahuanState('listData', listData);
      setManajemenPengetahuanState('pagination', response?.data.pagination);
      setManajemenPengetahuanState('loadingData', false);
    } catch (error) {
      setManajemenPengetahuanState('loadingData', false);
      throw error;
    }
  };

  const getDetailPengetahuan = async (id: string) => {
    setManajemenPengetahuanState('loadingData', true);
    try {
      const response = await axiosInstance.get(url + '/' + id);

      if (response?.data?.code === 200) {
        setManajemenPengetahuanState('pengetahuanItem', response?.data?.data);
        setManajemenPengetahuanState('mode', 'view');

        handleEdit(response?.data?.data);
      }
    } catch (error) {
      throw error;
    } finally {
      setManajemenPengetahuanState('loadingData', false);
    }
  };

  const getListKategoriPengetahuan = async () => {
    try {
      const response = await axiosInstance.get(urlKategoriPengetahuan, {
        params: {
          paginate: false,
        },
      });

      const dataKategoriPengetahuan = response.data.data.map((e) => {
        return {
          value: e.id,
          label: e.nama,
        };
      });

      setManajemenPengetahuanState(
        'listKategoriPengetahuan',
        dataKategoriPengetahuan
      );
    } catch (error) {
      throw error;
    }
  };

  const getPelatihanRelevan = async (keyword = '') => {
    try {
      const response = await axiosInstance.get(urlPelatihan, {
        params: {
          paginate: true,
          keyword,
        },
      });

      const dataPelatihan = response.data.data.map((e) => {
        return {
          value: e.id,
          label: e.judul_pelatihan,
        };
      });

      setManajemenPengetahuanState(
        'listPelatihan',
        dataPelatihan
      );
    } catch (error) {
      throw error;
    }
  }

  const getPengetahuanUtama = async () => {
    try {
      const response = await axiosInstance.get(urlPengetahuanUtama, {
        params: {
          paginate: false,
          tipe_klinik_khusus: 'UTAMA'
        },
      });

      const dataPengetahuanUtama = response.data.data.map((e) => {
        return {
          value: e.id,
          label: e.title,
        };
      });

      setManajemenPengetahuanState(
        'listPengetahuanUtama',
        dataPengetahuanUtama
      );
    } catch (error) {
      throw error;
    }
  }

  const getListPrasyaratMandiri = async (tipe: string) => {
    try {
      let options: Option[] = [];

      if (tipe === 'JABATAN') {
        const { data } = await axiosInstance.get('simdiklat/master_data/jabatan');
        options = (data?.data ?? []).map((item) => ({ value: item.nama, label: item.nama }));
      } else if (tipe === 'STATUS_PEGAWAI') {
        const { data } = await axiosInstance.get('simdiklat/master_data/status_pegawai');
        options = (data?.data ?? []).map((item) => ({ value: item.value, label: item.value }));
      } else if (tipe === 'PROVINSI') {
        const cached = getCache<Option[]>(CACHE_KEYS.LIST_PROVINSI);
        if (cached) {
          options = cached;
        } else {
          const provinsiPresenter = container.resolve(ProvinsiPresenter);
          const listProvinsi = await provinsiPresenter.getAllProvinsi(1, 50, '');
          options = listProvinsi.map((item) => ({ value: item.nama_provinsi, label: item.nama_provinsi }));
          setCache(CACHE_KEYS.LIST_PROVINSI, options, CACHE_TTL.MASTER_DATA);
        }
      }

      setManajemenPengetahuanState('listPrasyaratMandiri', options);
    } catch (error) {
      console.error('Error fetching list prasyarat mandiri:', error);
    }
  };

  const getListTipeMandiri = async () => {
    try {
      const { data } = await axiosInstance.get(
        'management_content/pengetahuan/options/tipe-klinik-khusus-mandiri'
      );
      const options = (data?.data ?? []).map((item) => ({
        value: item.value,
        label: item.label,
      }));
      setManajemenPengetahuanState('listTipeMandiri', options);
    } catch (error) {
      console.error('Error fetching list tipe mandiri:', error);
    }
  };

  const showToast = (title: string, status: ToastStatus = 'error') => {
    toast({
      title,
      status,
      position: 'top-right',
      duration: 3000,
      isClosable: true,
    });
  };

  const validateInput = () => {
    if (!title) {
      showToast('Judul harus diisi');
      if (title.length > 30) {
        showToast('Maksimal judul 30 karakter');
      }
      return false;
    }

    if (!image) {
      showToast('Cover Thumbnail harus diisi');
      return false;
    }

    if (!description) {
      showToast('Informasi Umum harus diisi');
      return false;
    }

    if (!organizer) {
      showToast('Penyelenggara harus diisi');
      return false;
    }

    if (!is_klinik_khusus || (is_klinik_khusus && kategoriKlinikKhusus?.value === "SUB")) {
      if (!review_url) {
        showToast('Link kuesioner harus diisi');
        return false;
      }
      const urlPattern = /^(https?:\/\/[^\s]+)$/i;
      if (!urlPattern.test(review_url)) {
        showToast('Link kuesioner harus berupa URL yang valid (http/https)');
        return false;
      }
    }

    return true;
  };

  const createFormData = () => {
    const formData = new FormData();
    formData.append('title', title);
    formData.append('nama_penyelenggara', organizer);
    formData.append(
      'kategori_pengetahuan_id',
      kategoriPengetahuanId ? kategoriPengetahuanId.value : ''
    );
    formData.append('description', description);
    formData.append('status_publish', publish ? '1' : '0');
    formData.append('jenis_pengetahuan', type);

    if (!is_klinik_khusus || (is_klinik_khusus && kategoriKlinikKhusus?.value === "SUB")) {
      formData.append('review_url', review_url);
    }

    if (type === 'synchronized') {
      formData.append('jadwal_mulai', moment(startDate).format('YYYY-MM-DD HH:mm:ss'));
      formData.append('jadwal_selesai', moment(endDate).format('YYYY-MM-DD HH:mm:ss'));
      formData.append('link_streaming', linkStream);
      formData.append('category', 'streaming');
      formData.append('jam_pelajaran', jam_pelajaran);
      
      formData.append('is_klinik_khusus', is_klinik_khusus ? '1' : '0');

      if (is_klinik_khusus) {
        if (kategoriKlinikKhusus?.value) {
          formData.append('tipe_klinik_khusus', kategoriKlinikKhusus.value);
        }
        if(kategoriKlinikKhusus?.value === 'UTAMA' && pelatihanSelected){
          pelatihanSelected.forEach((item) => {
            formData.append('pelatihan_id[]', item.value);
          });
        }else{
          formData.append('parent_id', pengetahuanUtamaSelected ? pengetahuanUtamaSelected.value : '');
        }
      }
    }
    if (image instanceof File) {
      formData.append('thumbnail', image);
    }

    if (category) {
      formData.append('category', category.value);
      if (youtubeVideoSelected && category.value === 'video') {
        formData.append('path_file', youtubeVideoSelected.value);
      }
      if (pdf && category.value === 'pdf') {
        if (pdf instanceof File) {
          formData.append('path_file', pdf);
        }
      }
    }

    if (hasQuiz) {
      formData.append('paket_soal_id', paketSoalId.toString());
      formData.append('durasi_quiz', duration.toString());
    }

    if (hasAssesment) {
      formData.append('judul_asesmen', titleAssesment);
      formData.append('keterangan_asesmen', descriptionAssesment);
      filesAssesment.forEach((file, index) => {
        if (file.url) {
          formData.append(`path_file_assessment[${index}]`, file.url);
        } else {
          formData.append(`path_file_assessment[${index}]`, file as File);
        }
      });
    }

    if (customSertifikat instanceof File) {
      formData.append('custom_background_sertifikat', customSertifikat);
    }

    if (keteranganSertifikat) {
      formData.append('keterangan_sertifikat', keteranganSertifikat);
    }

    const isUtamaKlinikKhusus =
      is_klinik_khusus && kategoriKlinikKhusus?.value === 'UTAMA';

    if (isUtamaKlinikKhusus) {
      const isMandiri = jenisPersyaratan === 'mandiri';
      formData.append('is_mandiri', isMandiri ? '1' : '0');

      if (isMandiri && tipe_klinik_khusus_mandiri) {
        const allowedTipe = listTipeMandiri.map((t) => t.value);
        if (allowedTipe.includes(tipe_klinik_khusus_mandiri.value)) {
          formData.append(
            'tipe_klinik_khusus_mandiri',
            tipe_klinik_khusus_mandiri.value
          );
          const allowedPrasyarat = listPrasyaratMandiri.map((p) => p.value);
          prasyarat_klinik_khusus_mandiri
            .filter((item) => allowedPrasyarat.includes(item.value))
            .forEach((item, index) => {
              formData.append(
                `prasyarat_klinik_khusus_mandiri[${index + 1}]`,
                item.value
              );
            });
        }
      } else if (jenisPersyaratan === 'pendalaman_pelatihan') {
        pelatihanPrasyaratSelected.forEach((item) => {
          formData.append('pelatihan_id[]', item.value);
        });
      }
    }

    return formData;
  };

  const postData = async () => {
    if (!validateInput()) {
      return;
    }

    setManajemenPengetahuanState('loadingAction', true);

    const formData = createFormData();

    try {
      const idParams = mode === 'edit' ? '/' + itemId : '';
      const response = await axiosInstance.post(`${url}${idParams}`, formData);
      clearState();
      setManajemenPengetahuanState('loadingAction', false);

      toast({
        title: response.data?.message,
        status: 'success',
        position: 'top-right',
        duration: 3000,
        isClosable: true,
      });
      if (mode === 'edit') {
        history.push('/admin/manajemen_pengetahuan');
      } else {
        setManajemenPengetahuanState('mode', '');
        fetchData();
      }

      return response.data;
    } catch (error) {
      setManajemenPengetahuanState('loadingAction', false);
      const responseData = error.response?.data;
      const titleMessage = responseData.message;

      if (responseData.code === 422) {
        Object.keys(responseData.errors).forEach((key) => {
          responseData.errors[key].forEach((errorMessage) => {
            toast({
              title: titleMessage,
              description: errorMessage,
              status: 'error',
              position: 'top-right',
              duration: 3000,
              isClosable: true,
            });
          });
        });
      }

      toast({
        title: 'Terjadi kesalahan saat menyimpan data',
        status: 'error',
        position: 'top-right',
        duration: 3000,
        isClosable: true,
      });

      throw error;
    }
  };

  const handleEdit = (pengetahuanItem) => {
    if (pengetahuanItem) {
      const categorytSelected = listCategory.find(
        (item) => item.value === pengetahuanItem?.category
      );

      setManajemenPengetahuanState('title', pengetahuanItem?.title);
      setManajemenPengetahuanState('category', categorytSelected);
      setManajemenPengetahuanState('description', pengetahuanItem?.description);
      setManajemenPengetahuanState('image', pengetahuanItem?.thumbnail);

      setManajemenPengetahuanState(
        'publish',
        pengetahuanItem?.status_publish === 0 ? false : true
      );

      setManajemenPengetahuanState('organizer',
        pengetahuanItem?.nama_penyelenggara
      );
      setManajemenPengetahuanState('startDate', pengetahuanItem?.jadwal_mulai);
      setManajemenPengetahuanState('endDate', pengetahuanItem?.jadwal_selesai);
      setManajemenPengetahuanState('jam_pelajaran', pengetahuanItem?.jam_pelajaran || '');
      setManajemenPengetahuanState(
        'linkStream',
        pengetahuanItem?.link_streaming
      );
      setManajemenPengetahuanState('type', pengetahuanItem?.jenis_pengetahuan);

      if (categorytSelected?.value === 'pdf') {
        setManajemenPengetahuanState('pdf', pengetahuanItem?.path_file);
      }

      if (pengetahuanItem?.paket_soal_id) {
        setManajemenPengetahuanState('hasQuiz', true);
        setManajemenPengetahuanState(
          'paketSoalId',
          pengetahuanItem?.paket_soal_id
        );
        setManajemenPengetahuanState('duration', pengetahuanItem?.durasi_quiz);
      }

      if (pengetahuanItem?.has_assessment) {
        setManajemenPengetahuanState('hasAssesment', true);
        setManajemenPengetahuanState(
          'titleAssesment',
          pengetahuanItem?.assessment?.judul
        );
        setManajemenPengetahuanState(
          'descriptionAssesment',
          pengetahuanItem?.assessment?.keterangan
        );

        const updateFilesAssesment =
          pengetahuanItem?.assessment?.assessment_files.map((item) => {
            return {
              url: item.path_file,
              name: item.nama_file,
              type: item.mime_type,
            };
          });

        setManajemenPengetahuanState('filesAssesment', updateFilesAssesment);
      }

      setManajemenPengetahuanState('review_url', pengetahuanItem?.review_url)
      setManajemenPengetahuanState('customSertifikat', pengetahuanItem?.custom_background_sertifikat);
      setManajemenPengetahuanState('keteranganSertifikat', pengetahuanItem?.keterangan_sertifikat || '');

      if(pengetahuanItem?.is_klinik_khusus){
        setManajemenPengetahuanState('is_klinik_khusus', pengetahuanItem?.is_klinik_khusus);

        // note
        // Stores the initial value from the server for "Klinik khusus and Kategori Klinik" status.
        // This ensures that when the user changes the input, the UI doesn't immediately reflect the change.
        setManajemenPengetahuanState('isKlinikKhususServer', pengetahuanItem.is_klinik_khusus);
        setManajemenPengetahuanState('isKategoriKlinikServer', pengetahuanItem.tipe_klinik_khusus);

        const categoryKlinikKhususSelected = listKategoriKlinikKhusus.find(
          (item) => item.value === pengetahuanItem?.tipe_klinik_khusus
        );
        setManajemenPengetahuanState('kategoriKlinikKhusus', categoryKlinikKhususSelected);
        if(pengetahuanItem?.tipe_klinik_khusus === 'UTAMA'){
          const selectedOptions = pengetahuanItem.pelatihans.map((p) => ({
            value: p.id,
            label: p.judul_pelatihan,
          }));

          setManajemenPengetahuanState('pelatihanSelected', selectedOptions);
          setManajemenPengetahuanState(
            'pelatihanPrasyaratSelected',
            selectedOptions
          );

          if (!pengetahuanItem?.is_mandiri) {
            setManajemenPengetahuanState(
              'jenisPersyaratan',
              'pendalaman_pelatihan'
            );
          }
        }else{
          const fetchPengetahuanUtama = async () => {
            const response = await axiosInstance.get(urlPengetahuanUtama, {
              params: {
                paginate: false,
                tipe_klinik_khusus: 'UTAMA'
              },
            });
            if (response.status === 200) {
              const dataPengetahuanUtama = response.data.data.map((e) => {
                return {
                  value: e.id,
                  label: e.title,
                };
              });

              const pengetahuanUtama = dataPengetahuanUtama.find(
                 (item) => item.value === pengetahuanItem?.parent_id 
              );
              setManajemenPengetahuanState('pengetahuanUtamaSelected', pengetahuanUtama);
            }
          };

          fetchPengetahuanUtama();
        }
      }

      if (pengetahuanItem?.is_mandiri) {
        setManajemenPengetahuanState('jenisPersyaratan', 'mandiri');

        const mandiriPrasyarat =
          pengetahuanItem.pengetahuan_mandiri_prasyarat ?? [];
        const tipeMandiriFromList = mandiriPrasyarat[0]?.type;
        const tipeMandiriFromDetail =
          pengetahuanItem.tipe_klinik_khusus_mandiri ?? tipeMandiriFromList;

        const tipeFound = listTipeMandiri.find(
          (item) => item.value === tipeMandiriFromDetail
        );
        const fallbackTipe = tipeMandiriFromDetail
          ? {
            value: tipeMandiriFromDetail,
            label: tipeMandiriFromDetail,
          }
          : null;
        setManajemenPengetahuanState(
          'tipe_klinik_khusus_mandiri',
          tipeFound ?? fallbackTipe
        );

        const prasyaratFromList = mandiriPrasyarat.map((item) => item.prasyarat);
        const prasyaratValues =
          prasyaratFromList.length > 0
            ? prasyaratFromList
            : pengetahuanItem.prasyarat_klinik_khusus_mandiri ?? [];
        const prasyaratOpts = prasyaratValues.map((val: string) => ({
          value: val,
          label: val,
        }));
        setManajemenPengetahuanState('prasyarat_klinik_khusus_mandiri', prasyaratOpts);

        if (tipeMandiriFromDetail) {
          getListPrasyaratMandiri(tipeMandiriFromDetail);
        }
      }

      setManajemenPengetahuanState('itemId', pengetahuanItem?.id);
      // setManajemenPengetahuanState("mode", "edit");
    }
  };

  const handleSeeDetail = (id) => {
    setManajemenPengetahuanState('itemId', id);
    setManajemenPengetahuanState('mode', 'detail');
  };
  const handleDelete = async (id) => {
    setManajemenPengetahuanState('isLoadingDelete', true);
    try {
      const response = await axiosInstance.delete(`${url}/${id}`);

      toast({
        title: response.data?.message,
        status: 'success',
        position: 'top-right',
        duration: 3000,
        isClosable: true,
      });

      history.push('/admin/manajemen_pengetahuan');

      return response.data;
    } catch (error) {
      toast({
        title: error?.message,
        status: 'error',
        position: 'top-right',
        duration: 3000,
        isClosable: true,
      });
      throw error;
    } finally {
      setManajemenPengetahuanState('isLoadingDelete', false);
    }
  };

  const clearState = () => {
    setManajemenPengetahuanState('title', '');
    setManajemenPengetahuanState('kategoriPengetahuanId', '');
    setManajemenPengetahuanState('description', '');
    setManajemenPengetahuanState('publish', false);
    setManajemenPengetahuanState('video', null);
    setManajemenPengetahuanState('pdf', null);
    setManajemenPengetahuanState('image', null);
    setManajemenPengetahuanState('youtubeVideoSelected', null);
    setManajemenPengetahuanState('category', null);
    setManajemenPengetahuanState('organizer', '');
    setManajemenPengetahuanState('type', 'asynchronized');
    setManajemenPengetahuanState('linkStream', '');
    setManajemenPengetahuanState('startDate', '');
    setManajemenPengetahuanState('endDate', '');
    setManajemenPengetahuanState('jam_pelajaran', '');
    setManajemenPengetahuanState('paketSoalId', 0);
    setManajemenPengetahuanState('duration', 0);
    setManajemenPengetahuanState('hasQuiz', false);
    setManajemenPengetahuanState('hasAssesment', false);
    setManajemenPengetahuanState('titleAssesment', '');
    setManajemenPengetahuanState('descriptionAssesment', '');
    setManajemenPengetahuanState('filesAssesment', []);
    setManajemenPengetahuanState('is_klinik_khusus', false);
    setManajemenPengetahuanState('kategoriKlinikKhusus', null);
    setManajemenPengetahuanState('pelatihanSelected', null);
    setManajemenPengetahuanState('pengetahuanUtamaSelected', null);
    setManajemenPengetahuanState('customSertifikat', null);
    setManajemenPengetahuanState('keteranganSertifikat', '');
    setManajemenPengetahuanState('jenisPersyaratan', '');
    setManajemenPengetahuanState('pelatihanPrasyaratSelected', []);
    setManajemenPengetahuanState('tipe_klinik_khusus_mandiri', null);
    setManajemenPengetahuanState('prasyarat_klinik_khusus_mandiri', []);
    setManajemenPengetahuanState('listPrasyaratMandiri', []);
  };

  return (
    <ManajemenPengetahuanProvider
      value={{
        state: state.state,
        setManajemenPengetahuanState,
        fetchData,
        postData,
        handleEdit,
        handleDelete,
        clearState,
        getListKategoriPengetahuan,
        handleSeeDetail,
        getDetailPengetahuan,
        getPelatihanRelevan,
        getPengetahuanUtama,
        getListPrasyaratMandiri,
        getListTipeMandiri,
      }}
    >
      {children}
    </ManajemenPengetahuanProvider>
  );
};

export const useManajemenPengetahuanContext = () => useContext(Context);

const ManajemenPengetahuanContext = {
  useManajemenPengetahuanContext,
  Provider,
};

export default ManajemenPengetahuanContext;
